export default __webpack_public_path__ + "static/gmeet-3e7ba5e061666a1df59c8383de0ac4d1.png";